import ButtonBox from './ButtonBox'
import ButtonRound from './ButtonRound'

const Widgets = {
	ButtonBox,
	ButtonRound
}

export default Widgets
